function logUserGroupEditor($http, $q, $rootScope, $uibModal, batchRequest, $location, errorHandler, userService) {
	return {
		template: require('./log-user-group-editor.html'),
		
		link: {
			pre: function(scope, el, attrs) {
				scope.groups = [];
				scope.groupsSrc = [];
				scope.logUsers = [];
				scope.logUsersSrc = [];
				scope.groupUserMap = {};
				
				scope.loadingGroups = false;
				scope.loadingMembers = false;
				scope.loadingUsers = false;
				
				scope.editingMode = false;
				scope.saveInProgress = false;
				
				let changeMap = {}
				
				function modifyTableArrays(func) {
					try {
						if (typeof func === 'function')
							func();
					}
					finally {
						scope.groupsSrc = Array.from(scope.groups);
						scope.logUsersSrc = Array.from(scope.logUsers);
					}
				}
				
				scope.fetchGroups = () =>
					$http.get('/api/logUserGroups', {
						params: {
							log: $rootScope.selectedLog.id,
							sort: 'name,desc',
							size: 1000
						}
					})
					.then(res => res.data._embedded.logUserGroups)
				
				scope.fetchLogUsers = () =>
					$http.get('/api/logUsers', {
						params: {
							log: $rootScope.selectedLog.id
						}
					})
					.then(res => res.data._embedded.logUsers)
				
				scope.updateGroups = () => {
					scope.loadingGroups = true;
					return scope.fetchGroups()
						.then(groups => modifyTableArrays(() => scope.groups = groups))
						.finally(() => scope.loadingGroups = false)
				}
				
				scope.updateLogUsers = () => {
					scope.loadingUsers = true;
					return scope.fetchLogUsers()
						.then(logUsers => modifyTableArrays(() => scope.logUsers = logUsers))
						.finally(() => scope.loadingUsers = false)
				}
				
				scope.updateMemberStatuses = () => {
					scope.loadingMembers = true;

					const groupId = scope.selectedGroup && scope.selectedGroup.id;
					if (!groupId)
						return $q.resolve();
						
					return userService.getLogUserGroupMembers(groupId).toPromise()
						.then(groupUsers => {
							scope.selectedGroup.users = groupUsers;

							scope.groupUserMap = scope.logUsers.reduce((map, lgUsr) => {
								const gUsr = groupUsers.find(gUsr => gUsr.user.id == lgUsr.id);
								map[lgUsr.id] = gUsr ? gUsr.id : null;

								return map;
							}, {});
						})
						.then(() => {
							modifyTableArrays(() => scope.logUsers = Array.from(scope.logUsers));
							scope.loadingMembers = false;
						});
				}
				
				scope.saveGroup = (name, group) => {
					const config = { noErrorPopup: true, returnError: true };
					return ((group)
						? $http.patch(group._links.self.href, {name: name}, config)
							.then(
								(res) => modifyTableArrays(() => group.name = res.data.name),
								(err) => {
									return scope.verifySelectedGroupExists()
										.then(exists => {
											if (exists) return $q.reject(err);
											scope.showAlertModal(null, `${group.name} has been previously
												deleted and has been removed from the list.`)
										}, () => $q.reject(err))
								})
						: $http.post('/api/logUserGroups', {
							name: name,
							log: $rootScope.selectedLog._links.self.href
						}, config)
							.then(res => {
								modifyTableArrays(() => scope.groups.push(res.data));
								scope.selectGroup(res.data, true);
							}))
						.catch(err => {
							let error = err.statusText || err.errorMessage;
							try {
								error = `${JSON.stringify(err.data, null, 2)}\n\n${new Error(error).stack}`;
							} catch (e) {
								error = `${error}\n\n${e.stack}`
							}
							errorHandler.handle(err.statusText || err.errorMessage, error, false);
							scope.showAlertModal(null, `An error occurred saving your changes.`)
						})
				}
				
				scope.doesGroupExist = (group) => {
					const id = group.id ? group.id : group;
					return new $q((resolve, reject) => {
						if (isNaN(parseInt(id)))
						{
							reject(NaN);
							return;
						}
						resolve(parseInt(id));
					})
						.then(groupId =>
							$http.get('/api/logUserGroups', {
								params: {
									log: $rootScope.selectedLog.id,
									id: groupId
								}
							})
							.then(res => res.data._embedded.logUserGroups.length >= 1));
				}
				
				scope.verifySelectedGroupExists = () =>
					scope.doesGroupExist(scope.selectedGroup)
						.then(exists => exists
							? exists
							: scope.updateGroups()
								.then(scope.selectGroup)
								.then(() => exists));
				
				scope.deleteGroup = (group) => {
					if (!group || !group._links) return $q.reject();
					return $http.delete(group._links.self.href, {
						noErrorPopup: true,
						returnError: true
					})
						.catch((err) => scope.doesGroupExist(group)
								.then(exists => exists ? $q.reject(err) : $q.resolve(),
									() => $q.reject(err)))
						.then(() => {
							const deletedIndex = scope.groups.findIndex(g => g.id === group.id);
							modifyTableArrays(() => {
								scope.groups.splice(deletedIndex, 1);
							})
							
							if (group !== scope.selectedGroup) return;
							const toSelectIndex = deletedIndex >= scope.groups.length ? scope.groups.length - 1 : deletedIndex;
							
							// If in mobile, return user to group list instead of selecting next group.
							return scope.selectGroup(scope.isMobile() ? null : scope.groups[toSelectIndex]);
							
						}, (err) => {
							let error = err.statusText || err.errorMessage;
							try {
								error = `${JSON.stringify(err.data, null, 2)}\n\n${new Error(error).stack}`;
							}
							catch (e) {
								error = `${error}\n\n${e.stack}`
							}
							errorHandler.handle(err.statusText || err.errorMessage, error, false);
							scope.showAlertModal('Delete Error', `An error occurred deleting ${group.name}`)
						})
				}
				
				scope.selectGroup = (group, promptUnsaved) =>
				{
					const groupId = (group && parseInt(group.id)) ? parseInt(group.id) : null;
					return scope.exitEditingMode(false, promptUnsaved)
						.then(() => {
							scope.selectedGroup = groupId ? group : undefined;
							scope.groupUserMap = {};
							$location.search('group', groupId).replace()
							return scope.updateMemberStatuses()
								.catch(err =>
									scope.verifySelectedGroupExists()
										.then(exists => {
												if (exists) return $q.reject(err);
												scope.showAlertModal(null, `${group.name} has been previously
												deleted and has been removed from the list.`);
											}, () => $q.reject(err)))
								.catch(err => {
									let error = err.statusText || err.errorMessage;
									try {
										error = `${JSON.stringify(err.data, null, 2)}\n\n${new Error(error).stack}`;
									}
									catch (e) {
										error = `${error}\n\n${e.stack}`
									}
									errorHandler.handle(err.statusText || err.errorMessage, error, false);
									scope.showAlertModal(null, `An error occurred selecting ${group.name}`)
									return scope.updateGroups()
										.then(() => scope.selectGroup(null));
								});
						})
				}
				
				scope.setGroupMember = (logUserId, isMember) => {
					changeMap[logUserId] = !!isMember;
				}
				
				scope.isGroupMember = (logUserId, bypassEditingMode) => {
					return (scope.editingMode && !bypassEditingMode && logUserId in changeMap)
						? changeMap[logUserId]
						: typeof scope.groupUserMap[logUserId] === 'number'
				};
				
				scope.hasEdit = (logUserId) =>
					scope.editingMode && logUserId in changeMap;
				
				scope.hasEdits = () =>
					scope.editingMode && !!Object.keys(changeMap).length;
				
				scope.showGroupNameModal = (group) => {
					const name = group ? group.name : '';
					let $closeModal;
					
					const listenEvent = function ($event) {
						if ($event.which === 13 && ($event.currentTarget.nodeName === 'INPUT' || $event.shiftKey) && typeof $closeModal === 'function')
							$closeModal();
					}
					$(document).on('keypress', '.modal-content input', listenEvent)
					
					$uibModal.open({
						backdrop: 'static',
						controller: ['$scope', function(modalScope) {
							modalScope.name = name;
							$closeModal = function(){
								if (!modalScope.name.length) return;
								modalScope.$close(modalScope.name);
							};
						}],
						template:
							'<div class="modal-body">' +
								'<input ng-model="name" placeholder="Group Name" class="form-control" autofocus="autofocus">' +
							'</div>' +
							'<div class="modal-footer">' +
								'<button class="btn btn-default" ng-click="$dismiss()">Cancel</button>' +
								'<button class="btn btn-primary" ng-click="$close(name)" ng-disabled="!name.length">Save</button>' +
							'</div>'
					}).result
						.then(name => scope.saveGroup(name, group))
						.finally(() => {
							$(document).off('keypress', listenEvent)
						})
				}
				
				scope.showEarlyExitModal = () =>
					$uibModal.open({
						template: require('app/shared/modals/modal-confirm.html'),
						controller: ['$scope', function(modalScope) {
							modalScope.message = 'You have unsaved changes. Are you sure you want to leave?'
						}]
					})
						.result;
				
				scope.showAlertModal = (title, body) =>
					$uibModal.open({
						template: require('app/shared/modals/modal-alert.html'),
						controller: ['$scope', function(scope){
							scope.title = title;
							scope.body = body;
						}]
					})
				
				scope.enterEditingMode = () => {
					scope.editingMode = true;
					scope.resetChangeMap();
				}
				
				scope.exitEditingMode = (save, showUnsavedModal) => {
					save = (typeof save === 'boolean') ? save && Object.keys(changeMap).length : false;
					
					const defer = $q.defer();
					defer.promise.then(() => {
						scope.resetChangeMap();
						scope.saveInProgress = false;
						scope.editingMode = false;
					})
					
					if (save)
					{
						scope.saveInProgress = true;
						const reqs = Object.keys(changeMap)
							.reduce((arr, lgUsrId) => {
								const original = scope.isGroupMember(lgUsrId, true);
								const groupUsrId = scope.groupUserMap[lgUsrId];
								const newState = changeMap[lgUsrId];
								
								if (original === newState) return arr;
								
								const req = batchRequest.req(
									newState ? 'POST' : 'DELETE',
									newState ? '/api/logUserGroupMembers' : `/api/logUserGroupMembers/${groupUsrId}`,
									newState ? {
										user: `/api/logUsers/${lgUsrId}`,
										group: `/api/logUserGroups/${scope.selectedGroup.id}`
									} : undefined
								)
								arr.push(req);
								return arr;
						}, []);
						
						defer.resolve((reqs.length
							? batchRequest.all(reqs, { noErrorPopup: true, returnError: true })
									.then(() => scope.updateMemberStatuses().catch(() => $q.resolve()))
									.catch(err => {
										return scope.verifySelectedGroupExists()
											.then(
												exists => {
													if (exists) return $q.reject(err);
													scope.showAlertModal(null, 'This group has been previously deleted. No Changes have been saved.');
											}, () => $q.reject(err))
									})
									.catch((err) => {
										let error = err.statusText || err.errorMessage;
										try {
											error = `${JSON.stringify(err.data, null, 2)}\n\n${new Error(error).stack}`;
										}
										catch (e) {
											error = `${error}\n\n${e.stack}`
										}
										errorHandler.handle(err.statusText || err.errorMessage, error, false);
										scope.showAlertModal('Save Error',
											'An error occurred while saving your changes.');
									})
							: $q.resolve()
						)
						);
					}
					else
						defer.resolve(showUnsavedModal && scope.hasEdits() ? scope.showEarlyExitModal() : $q.resolve());
					
					return defer.promise;
				}
				
				scope.resetChangeMap = () => changeMap = {}
				
				scope.fullRefresh = () => $q.all([scope.updateLogUsers(), scope.updateGroups()]);
				
				scope.isMemberFilter = function(logUser) {
					return scope.editingMode || scope.isGroupMember(logUser.id);
				}
				
				scope.isMemberGetter = (user) => scope.isGroupMember(user.id) ? -1 : 1;
				
				scope.isAdmin = () => $rootScope.selectedLog && $rootScope.selectedLog.role === 'ADMIN';
				
				scope.isMobile = () => window.innerWidth < 768
				
			},
			
			post: function(scope, el, attrs) {
				scope.fullRefresh()
					.then(() => {
						const editGroupId = parseInt($location.search()['group']);
						if (isNaN(editGroupId)) return;
						
						const group = scope.groups.find(group => group.id === editGroupId)
						return scope.selectGroup(group);
					});
				
				scope.$emit('setLazyTabsetConfirm', scope.hasEdits,
					'You have unsaved changes. Are you sure you want to leave?');
				
				scope.$on('$destroy', () => {
					$location.search('group', null);
				})
			}
		}
	}
}


angular.module('logbook').directive('logUserGroupEditor', ['$http', '$q', '$rootScope', '$uibModal', 'batchRequest',
	'$location', 'errorHandler', 'userService', logUserGroupEditor]);